import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../store';
import { UserLoginActionCreators } from '../store/Login';
import { CustomersEditor } from './Customers/CustomersEditor';
import { ProjectEditor } from './Projects/ProjectEditor';
import { ProjectAssigmentEditor } from './Projects/ProjectAssigmentEditor';
import { TimeSheetEditor } from './Projects/TimeSheetEditor';
import { InvoicesQuickView } from './Invoices/InvoicesQuickView';
import { CustomersQuickView } from './Customers/CustomersQuickView';
import { InvoicesEditor } from './Invoices/InvoicesEditor';
import { ConsultantsEditor } from './Consultants/ConsultantsEditor';
import { ProjectQuickView } from './Projects/ProjectQuickView';
import { ProjectsAssigmentsQuickView } from './Projects/ProjectsAssigmentsQuickView';
import { SalesEditor } from './Products/SalesEditor';
import { TimeSheetDeleteConfirm } from './Projects/TimeSheetDeleteConfirm';
import { ConsultantsQuickView } from './Consultants/ConsultantsQuickView';
import { TimeSheetQuickView } from './Projects/TimeSheetQuickView';
import { ProductsQuickView } from './Products/ProductsQuickView';
import { FileUploader } from './FileUploader';
import { ConsultantsInvoicesEditor } from './Consultants/ConsultantsInvoicesEditor';
import { ContactQuickView } from './Contacts/ContactQuickView';
import { ContactEditor } from './Contacts/ContactEditor';
import { Customer } from '../interfaces/Customer';
import { dataActionCreators, Invoice, Project, TimeSheetEntry } from '../store/Data';
import { ConsultantDocument } from '../interfaces/Consultant';
import { CustomersContactManagement } from './Customers/CustomersContactManagement';
import { ConsultantsDocumentsEditor } from './ConsultantsDocuments/ConsultantsDocumentsEditor';
import { ConsultantDocumentDeleteConfirm } from './ConsultantsDocuments/ConsultantDocumentDeleteConfirm';
import { ConsultantsDocumentsCreation } from './ConsultantsDocuments/ConsultantsDocumentsCreation';
import { AppItem, Avatar, Button, createPresenceComponent, DrawerBody, Hamburger, InlineDrawer, makeStyles, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger, MessageBar, MessageBarActions, MessageBarBody, motionTokens, NavCategory, NavCategoryItem, NavDivider, NavDrawer, NavDrawerBody, NavItem, NavItemValue, NavSectionHeader, NavSubItem, NavSubItemGroup, SplitNavItem, Switch, Toaster, tokens, Tooltip, useRestoreFocusTarget } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { FEVersion } from '../Version';
import { InvoicesGeneration } from './Invoices/InvoicesGeneration';
import { InvoiceSendEmail } from './Invoices/InvoicesSendEmail';
import { InvoicesSendUBL } from './Invoices/InvoicesSendUBL';
import { ProjectDeleteConfirm } from './Projects/ProjectDeleteConfirm';
import { ProjectsAssigmentsDeleteConfirm } from './Projects/ProjectsAssigmentsDeleteConfirm';
import { ConsultantsActivityPeriodesEditor } from './Consultants/ConsultantsActivityPeriodesEditor';
import { NavToLink } from './Tools/FileDownloadHelper';
import { PeppolReceivedDocs } from './ConsultantsDocuments/PeppolReceivedDocs';
import { PersonCircle32Regular } from '@fluentui/react-icons';
import type { MenuButtonProps, OnNavItemSelectData, SwitchOnChangeData } from '@fluentui/react-components';
import { useNavigate } from 'react-router-dom';
import { TeamsState } from '../store/TeamsState';
import { IPublicClientApplication } from '@azure/msal-browser';
import { availableLanguages } from '../TranslationInit';
import { useMsal } from "@azure/msal-react";
import { useTabStyles, ShiftsTeam20Icon, MoneyCalculator20Icon, PeopleTeam20Icon, DocumentFolder20Icon, Info20Icon, GlobeShield20Icon, AppsListDetail20Icon, DocumentDatabase20Icon, BoxSearch20Icon, TaskListSquareDatabase20Icon, TaskListSquarePerson20Icon, CardUi20Icon, ContactCard20Icon, BoxCheckmark20Icon, ContactCardRibbon20Icon, Board20Icon, BoxArrowUp20Icon, BoxArrowLeft20Icon, Box20Icon, Timeline20Icon } from './Styles/Editor';
import { useConsultants, useRigths } from './Tools/ObjectLoader';
import { ConsultantActionCreators } from '../store/consultants';
import { NeomyticConsultantID } from '../interfaces/Consultant';
import { customersActionCreators } from '../store/customers';
import { InvoiceDeleteConfirm } from './Invoices/InvoiceDeleteConfirm';
import { PeppolReceivedDocsDeleteConfirm } from './ConsultantsDocuments/PeppolReceivedDocsDeleteConfirm';
import { useMediaQuery } from '../DeviceInfo';
import { About } from './About';
import { SalesQuickView } from './Products/SalesQuickView';

const drawerWidth = "260px";
const drawerMargin = tokens.spacingVerticalM;

const useStyles = makeStyles({
    root: {
        overflow: "hidden",
        height: "100%",
        position: "relative",
        display: "flex",
        backgroundColor: tokens.colorNeutralBackground1,
    },
    nav: {
        minWidth: "200px",
        width: drawerWidth,
    },
    content: {
        flex: "1",
        padding: "16px",
        display: "grid",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gridAutoColumns: "100%",

        margin: 0,
        gap: tokens.spacingVerticalM,
        gridAutoRows: "max-content",
        boxSizing: "border-box",
        //position: "absolute",
        inset: 0,
        overflowY: "auto",
    },
});

/*
 * Create a custom DrawerMotion component that animates the drawer surface.
 */
const DrawerMotion = createPresenceComponent(() => {
    const keyframes = [
        {
            opacity: 0,
            transform: "translate3D(-100%, 0, 0)",
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0,
            marginBottom: 0,
            backgroundColor: tokens.colorNeutralBackground1,
            borderColor: tokens.colorNeutralBackground1,
            borderRadius: 0,
        },
        {
            opacity: 1,
            transform: "translate3D(0, 0, 0)",
            marginLeft: drawerMargin,
            marginRight: 0,
            marginTop: drawerMargin,
            marginBottom: drawerMargin,
            borderColor: tokens.colorNeutralBackground4,
            borderRadius: tokens.borderRadiusXLarge,
        },
    ];

    return {
        enter: {
            keyframes,
            duration: motionTokens.durationNormal,
            easing: motionTokens.curveDecelerateMin,
        },
        exit: {
            keyframes: [...keyframes].reverse(),
            duration: motionTokens.durationSlow,
            easing: motionTokens.curveAccelerateMin,
        },
    };
});
const DrawerMotion2 = createPresenceComponent(() => {
    const keyframes = [
        {
            opacity: 0,
            transform: "translate3D(100%, 0, 0)",
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0,
            marginBottom: 0,
            backgroundColor: tokens.colorNeutralBackground1,
            borderColor: tokens.colorNeutralBackground1,
            borderRadius: 0,
        },
        {
            opacity: 1,
            transform: "translate3D(0, 0, 0)",
            marginLeft: 0,
            marginRight: drawerMargin,
            marginTop: drawerMargin,
            marginBottom: drawerMargin,
            backgroundColor: tokens.colorBrandBackground2,
            borderColor: tokens.colorNeutralBackground4,
            borderRadius: tokens.borderRadiusXLarge,
        },
    ];

    return {
        enter: {
            keyframes,
            duration: motionTokens.durationNormal,
            easing: motionTokens.curveDecelerateMin,
        },
        exit: {
            keyframes: [...keyframes].reverse(),
            duration: motionTokens.durationSlow,
            easing: motionTokens.curveAccelerateMin,
        },
    };
});

/*
 * Create a custom ContentMotion component that animates the content element.
 */
const ContentMotion = createPresenceComponent(() => {
    const keyframes = [
        {
            //transform: "translate3D(0, 0, 0)",
            margin: 0,
            backgroundColor: tokens.colorNeutralBackground1,
            borderColor: tokens.colorNeutralBackground1,
            borderRadius: 0,
        },
        {
            //transform: `translate3D(100%, 0, 0)`,
            margin: drawerMargin,
            backgroundColor: tokens.colorNeutralBackground3,
            borderColor: tokens.colorNeutralBackground4,
            borderRadius: tokens.borderRadiusXLarge,
        },
    ];

    return {
        enter: {
            keyframes,
            duration: motionTokens.durationGentle,
            easing: motionTokens.curveDecelerateMin,
        },
        exit: {
            keyframes: [...keyframes].reverse(),
            duration: motionTokens.durationGentle,
            easing: motionTokens.curveAccelerateMin,
        },
    };
});

type LayoutProps = {
    children?:
    | React.ReactChild
    | React.ReactChild[];
};
export const Layout: React.FC<LayoutProps> = ({ children }) => {
    const dispatch = useDispatch();
    const { instance } = useMsal();
    const viewDebugInfo = useSelector((state: ApplicationState) => state.userNeomyticLogin.viewDebugInfo);
    const authStatus: TeamsState | undefined = useSelector<ApplicationState, TeamsState | undefined>((state: ApplicationState) => state.teamsState);
    const data = useSelector((state: ApplicationState) => state.data);
    const customerEdit = useSelector((state: ApplicationState) => state.customersState.customerEdit);
    const customerContactsEdit = useSelector((state: ApplicationState) => state.customersState.customerContactsEdit);
    const projectContactsEdit = useSelector<ApplicationState, Project | null>((state: ApplicationState) => state.data.projectContactsEdit);
    const contactsEdit = useSelector((state: ApplicationState) => state.contactsState.contactsEdit);
    const contactQuickView = useSelector((state: ApplicationState) => state.contactsState.contactQuickView);
    const customerQuickView = useSelector((state: ApplicationState) => state.customersState.customerQuickView);
    const consultantEdit = useSelector((state: ApplicationState) => state.consultantsState.consultantEdit);
    const consultantActivityPeriodesEdit = useSelector((state: ApplicationState) => state.consultantsState.consultantActivityPeriodesEdit);
    const consultantQuickView = useSelector((state: ApplicationState) => state.consultantsState.consultantQuickView);
    const consultantInvoiceEdit = useSelector((state: ApplicationState) => state.consultantsState.consultantInvoiceEdit);
    const consultantDocumentEdit = useSelector((state: ApplicationState) => state.consultantsState.consultantDocumentEdit);
    const consultantDocumentCreate = useSelector((state: ApplicationState) => state.consultantsState.consultantDocumentCreate);
    const consultantDocumentDelete = useSelector((state: ApplicationState) => state.consultantsState.consultantDocumentDelete);
    const invoiceGeneration = useSelector((state: ApplicationState) => state.data.invoiceGeneration);
    const invoiceEmail = useSelector((state: ApplicationState) => state.data.invoiceEmail);
    const invoiceSendUBL = useSelector((state: ApplicationState) => state.data.invoiceSendUBL);
    const invoiceToDelete = useSelector((state: ApplicationState) => state.data.invoiceToDelete);
    const projectDelete = useSelector((state: ApplicationState) => state.data.projectDelete);
    const projectAssigmentDelete = useSelector((state: ApplicationState) => state.data.projectAssigmentDelete);
    const peppolReceivedDocEdit = useSelector((state: ApplicationState) => state.data.peppolReceivedDocEdit);
    const consultantPeppolReceivedInvoicedeletion = useSelector((state: ApplicationState) => state.consultantsState.consultantPeppolReceivedInvoicedeletion);
    const salesQuickView = useSelector((state: ApplicationState) => state.data.salesQuickView);
    const stylesTab = useTabStyles();
    const styles = useStyles();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const { isAdmin, seeDebugInfo, consultantid, version } = useRigths();

    const teamsState = useSelector<ApplicationState, TeamsState>((state: ApplicationState) => state.teamsState);

    const [showAbout, setShowAbout] = React.useState(false);

    const isDesktop = useMediaQuery('(min-width: 1024px)');
    const [isOpen, setIsOpen] = React.useState<boolean>(isDesktop);
    React.useEffect(() => { setIsOpen(isDesktop); }, [isDesktop]);

    const [selectedValue, setSelectedValue] = React.useState<string>("NavToDashboard");
    const [openCategories, setOpenCategories] = React.useState<NavItemValue[]>([
    ]);
    const [selectedCategoryValue, setSelectedCategoryValue] = React.useState<
        string | undefined
    >("NavToDashboard");

    // Tabster prop used to restore focus to the navigation trigger for overlay nav drawers
    const restoreFocusTargetAttributes = useRestoreFocusTarget();
    const { consultants } = useConsultants();

    const consultantQuickView2 = consultants && consultants.length === 1
        ? consultants[0]
        : (consultants && consultantid
            ?
            consultants.find(c => consultantid !== undefined && c.consultantid === consultantid)
            :
            null
        );
    if (consultantQuickView2 === null || consultantQuickView2 === undefined) {
        return null;
    }

    let qv: JSX.Element | null = null;
    if (data.invoiceQuickView) {
        qv = <InvoicesQuickView />;
    }
    else if (customerQuickView) {
        qv = <CustomersQuickView />;
    }
    else if (data.projectQuickView) {
        qv = <ProjectQuickView />;
    }
    else if (data.projectAssigmentQuickView) {
        qv = <ProjectsAssigmentsQuickView />;
    }
    else if (consultantQuickView) {
        qv = <ConsultantsQuickView />;
    }
    else if (data.timesheetQuickView) {
        qv = <TimeSheetQuickView />;
    }
    else if (data.productQuickView) {
        qv = <ProductsQuickView />;
    }
    else if (contactQuickView) {
        qv = <ContactQuickView />;
    }
    else if (salesQuickView) {
        qv = <SalesQuickView />;
    }

    const handleItemSelect = (
        event: Event | React.SyntheticEvent<Element, Event>,
        data: OnNavItemSelectData
    ) => {
        if (data.value === "NavToAbout") {
            // Just show about dlg, but do not change other selections
            setShowAbout(true);
            if (!isDesktop) setIsOpen(false);
            return;
        }
        setSelectedValue(data.value as string);
        setSelectedCategoryValue(data.categoryValue as string ?? data.value as string);
        switch (data.value) {
            case "NavToDashboard":
                navigate("/Home");
                break;
            case "NavToTimeSheet":
                navigate("/TimeSheet");
                break;
            case "NavToConsultants":
                navigate("/Consultants");
                break;
            case "NavToConsultantsAllDoc":
                navigate("/ConsultantsDocuments");
                break;
            case "NavToNeomyticSellInvoices":
                navigate("/Invoices");
                break;
            case "NavToNeomyticSellCreditNotes":
                navigate("/CreditNotes");
                break;
            case "NavToNeomyticBuysInvoices":
                navigate("/NeomyticDocumentsBuys");
                break;
            case "NavToNeomyticAllDocs":
                navigate("/NeomyticDocuments");
                break;
            case "NavToCustomers":
                navigate("/Customers");
                break;
            case "NavToContacts":
                navigate("/Contacts");
                break;
            case "NavToProjects":
                navigate("/Projects");
                break;
            case "NavToProjectsAssigments":
                navigate("/ProjectsAssigments");
                break;
            case "NavToProducts":
                navigate("/Products");
                break;
            case "NavToSales":
                navigate("/Sales");
                break;
            case "NavToLogs":
                navigate("/Logs");
                break;
            case "NavToPeppolStatus":
                navigate("/PeppolSettings");
                break;
            case "NavToConsultantCustomrs":
                navigate("/CustomersFromConsultants");
                break;
            case "NavToConsultantDocss":
                navigate("/ConsultantsDocumentsPrivate");
                break;
            case "NavToConsultantTimeSheet":
                navigate("/PrivateTimeSheet");
                break;
            case "NavToConsultantSales":
                navigate("/ConsultantsDocumentsPrivateMySells");
                break;
            case "NavToConsultantBuys":
                navigate("/ConsultantsDocumentsPrivateMyBuys");
                break;
        }
        if (!isDesktop) setIsOpen(false);
    };
    const handleCategoryToggle = (
        _: Event | React.SyntheticEvent<Element, Event>,
        data: OnNavItemSelectData
    ) => {
        if (data.value === undefined && data.categoryValue) {
            // we're just opening it,
            setOpenCategories([data.categoryValue as string]);
        }

        // if it's already open, remove it from the list
        if (openCategories.includes(data.categoryValue as string)) {
            setOpenCategories(
                openCategories.filter((category) => category !== data.categoryValue)
            );
        } else {
            // otherwise add it
            setOpenCategories([...openCategories, data.categoryValue as string]);
        }
    };

    let title = "";
    switch (selectedValue) {
        case "NavToDashboard": title = "Dashboard"; break;
        case "NavToMyDashboard": title = t('MyDashboard'); break;
        case "NavToTimeSheet": title = "Timesheets"; break;
        case "NavToLogs": title = "Logs"; break;
        case "NavToPeppolStatus": title = "Peppol Status"; break;
        case "NavToNeomyticSellInvoices": title = t('Sells') + " (Neomytic)"; break;
        case "NavToNeomyticSellCreditNotes": title = t('CreditNotes') + " (Neomytic)"; break;
        case "NavToNeomyticBuysInvoices": title = t('Buys') + " (Neomytic)"; break;
        case "NavToNeomyticAllDocs": title = t('AllDocuments') + " (Neomytic)"; break;
        case "NavToConsultantsAllDoc": title = t('AllDocuments') + " (" + t('Consultants') + ")"; break;
        case "NavToConsultantCustomrs": title = t('MyCustomers'); break;
        case "NavToCustomers": title = t('Customers'); break;
        case "NavToContacts": title = "Contacts"; break;
        case "NavToProjects": title = t('Projects'); break;
        case "NavToProjectsAssigments": title = t('ProjectsAssigments'); break;
        case "NavToConsultantTimeSheet": title = t('MyTimeSheets'); break;
        case "NavToConsultantDocss": title = t('MyDocuments'); break;
        case "NavToConsultantSales": title = t('MySells'); break;
        case "NavToConsultantBuys": title = t('MyBuys'); break;
        case "NavToConsultants": title = t('Consultants'); break;
        case "NavToProducts": title = "Produits"; break;
        case "NavToSales": title = "Ventes"; break;
        default: break;
    }

    function handleLogout(instance: IPublicClientApplication) {
        instance.logoutRedirect().catch(e => {

        });
    }

    const OnNewInvoiceClick = (isNeomytic: boolean, isCreditNote: boolean) => {
        if (!consultantid) return;
        if (isNeomytic) {
            if (isCreditNote) {
                navigate("/CreditNotes");
                setSelectedValue("NavToNeomyticSellCreditNotes");
                setSelectedCategoryValue("NavToNeomyticSellCreditNotes");
            } else {
                navigate("/Invoices");
                setSelectedValue("NavToNeomyticSellInvoices");
                setSelectedCategoryValue("NavToNeomyticSellInvoices");
            }
        } else {
            if (isCreditNote) {
                return; // credit notes for consultants not implemented yet
            } else {
                navigate("/ConsultantsDocumentsPrivateMySells");
                setSelectedValue("NavToConsultantSales");
                setSelectedCategoryValue("NavToConsultantSales");
            }
        }
        const p: Invoice = {
            invoiceid: null,
            customerid: null,
            invoiceRef: null,
            invoiceDate: null,
            paymentDate: null,
            payment: 0,
            invoiceSharePointFileUniqueId: null,
            vatcode: 21,
            description: null,
            invoiceDescription: null,
            buyerReference: null,
            consultantid: isNeomytic ? NeomyticConsultantID : consultantid, // neomytic consultant or Logged in consultant
            pdfuploaded: false,
            prepaidAmount: null,
            lock: false,
            isCreditNote: isCreditNote,
        };
        dispatch(dataActionCreators.requestInvoiceEdition(p));
        if (!isDesktop) setIsOpen(false);
    };
    const OnNewDocumentClick = (nav: string, selValue: string, consid: string | null, documentType: number) => {
        if (!consultantid) return;
        navigate(nav);
        setSelectedValue(selValue);
        setSelectedCategoryValue(selValue);
        const pa: ConsultantDocument = {
            consultantdocumentid: "",
            consultantidPublisher: "",
            consultantid: consid,
            createDate: null,
            lastUpdateDate: null,
            documentSharePointFileUniqueId: "",
            documentSharePointFileOriginalName: "",
            documentTypeId: documentType,
            documentDate: null,
            documentSource: null,
            documentAmount: 0,
            lock: false,
            accountingRef: null,
            description: null,
        };
        dispatch(ConsultantActionCreators.requestConsultantDocumentCreation(pa));
        if (!isDesktop) setIsOpen(false);
    };

    return (
        <div id="LayoutRoot" className={styles.root}>
            <Toaster toasterId="NeoToasterUnique" />
            <NavDrawer
                id="LayoutNav"
                className={styles.nav}
                open={isOpen}
                type={"inline"}
                onOpenChange={(_, data) => setIsOpen(data.open)}
                surfaceMotion={{ children: (_, props) => <DrawerMotion {...props} /> }}
                onNavCategoryItemToggle={handleCategoryToggle}
                onNavItemSelect={handleItemSelect}
                tabbable={true} // enables keyboard tabbing
                openCategories={openCategories}
                selectedValue={selectedValue}
                selectedCategoryValue={selectedCategoryValue}
            >
                <NavDrawerBody>
                    <AppItem
                        value="NavToMyName"
                        icon={consultantQuickView2.photo
                            ?
                            <Avatar
                                className={stylesTab.AfterAvatarMargin}
                                size={48}
                                image={{
                                    alt: consultantQuickView2.displayName ? consultantQuickView2.displayName : "?",
                                    src: consultantQuickView2.photo,
                                }} />
                            :
                            <PersonCircle32Regular />
                        }
                        onClick={() => {
                            navigate("/HomeNonAdmin");
                            setSelectedCategoryValue(undefined);
                            setSelectedValue("NavToMyDashboard");
                            if (!isDesktop) setIsOpen(false);
                        }}
                    >
                        {(consultantQuickView2 && consultantQuickView2.displayName ? consultantQuickView2.displayName : "?")}
                    </AppItem>
                    {
                        //#region Neomytic Menu
                    }
                    {isAdmin &&
                        <>
                            <NavDivider />
                            <NavSectionHeader>Neomytic</NavSectionHeader>
                            <NavItem
                                icon={<Board20Icon style={{ fontSize: "48px" }} />}
                                value="NavToDashboard" >
                                Dashboard
                            </NavItem>
                            <NavItem
                                icon={<Timeline20Icon />}
                                value="NavToTimeSheet">
                                Timesheets
                            </NavItem>
                            <NavCategory value="CatNeomyticDocuments">
                                <NavCategoryItem icon={<DocumentFolder20Icon />} >Documents</NavCategoryItem>
                                <NavSubItemGroup>
                                    <Menu>
                                        <MenuTrigger>
                                            {(triggerProps: MenuButtonProps) => (
                                                <SplitNavItem
                                                    navItem={{
                                                        icon: < BoxArrowUp20Icon />,
                                                        value: "NavToNeomyticSellInvoices",
                                                        children: <><BoxArrowUp20Icon />{t('Sells')}</>,
                                                    }}
                                                    menuButton={triggerProps}
                                                    menuButtonTooltip={{
                                                        content: t('MoreOptions'),
                                                        relationship: "label",
                                                    }}
                                                />
                                            )}
                                        </MenuTrigger>
                                        <MenuPopover>
                                            <MenuList>
                                                <MenuItem onClick={() => OnNewInvoiceClick(true, false)}>{t('AddNewPeppolSell')}</MenuItem>
                                            </MenuList>
                                        </MenuPopover>
                                    </Menu>
                                    <Menu>
                                        <MenuTrigger>
                                            {(triggerProps: MenuButtonProps) => (
                                                <SplitNavItem
                                                    navItem={{
                                                        icon: < BoxArrowUp20Icon />,
                                                        value: "NavToNeomyticSellCreditNotes",
                                                        children: <><BoxArrowUp20Icon />{t('CreditNotes')}</>,
                                                    }}
                                                    menuButton={triggerProps}
                                                    menuButtonTooltip={{
                                                        content: t('MoreOptions'),
                                                        relationship: "label",
                                                    }}
                                                />
                                            )}
                                        </MenuTrigger>
                                        <MenuPopover>
                                            <MenuList>
                                                <MenuItem onClick={() => OnNewInvoiceClick(true, true)}>{t('AddNewPeppolCreditNote')}</MenuItem>
                                            </MenuList>
                                        </MenuPopover>
                                    </Menu>
                                    <Menu>
                                        <MenuTrigger>
                                            {(triggerProps: MenuButtonProps) => (
                                                <SplitNavItem
                                                    navItem={{
                                                        icon: < BoxArrowLeft20Icon />,
                                                        value: "NavToNeomyticBuysInvoices",
                                                        children: <><BoxArrowLeft20Icon />{t('Buys')}</>,
                                                    }}
                                                    menuButton={triggerProps}
                                                    menuButtonTooltip={{
                                                        content: t('MoreOptions'),
                                                        relationship: "label",
                                                    }}
                                                />
                                            )}
                                        </MenuTrigger>
                                        <MenuPopover>
                                            <MenuList>
                                                <MenuItem onClick={() => OnNewDocumentClick("/NeomyticDocumentsBuys", "NavToNeomyticBuysInvoices", NeomyticConsultantID, 101)}>{t('AddnewDocument')}</MenuItem>
                                            </MenuList>
                                        </MenuPopover>
                                    </Menu>
                                    <Menu>
                                        <MenuTrigger>
                                            {(triggerProps: MenuButtonProps) => (
                                                <SplitNavItem
                                                    navItem={{
                                                        icon: < Box20Icon />,
                                                        value: "NavToNeomyticAllDocs",
                                                        children: <><Box20Icon />{t('AllDocuments')}</>,
                                                    }}
                                                    menuButton={triggerProps}
                                                    menuButtonTooltip={{
                                                        content: t('MoreOptions'),
                                                        relationship: "label",
                                                    }}
                                                />
                                            )}
                                        </MenuTrigger>
                                        <MenuPopover>
                                            <MenuList>
                                                <MenuItem onClick={() => OnNewDocumentClick("/NeomyticDocuments", "NavToNeomyticAllDocs", NeomyticConsultantID, -1)}>{t('AddnewDocument')}</MenuItem>
                                            </MenuList>
                                        </MenuPopover>
                                    </Menu>
                                </NavSubItemGroup>
                            </NavCategory>
                            <NavCategory value="CatNeomyticConsultants">
                                <NavCategoryItem icon={<PeopleTeam20Icon />} >{t('Consultants')}</NavCategoryItem>
                                <NavSubItemGroup>
                                    <Menu>
                                        <MenuTrigger>
                                            {(triggerProps: MenuButtonProps) => (
                                                <SplitNavItem
                                                    navItem={{
                                                        icon: < BoxCheckmark20Icon />,
                                                        value: "NavToConsultantsAllDoc",
                                                        children: <><BoxCheckmark20Icon />{t('AllDocuments')}</>,
                                                    }}
                                                    menuButton={triggerProps}
                                                    menuButtonTooltip={{
                                                        content: t('MoreOptions'),
                                                        relationship: "label",
                                                    }}
                                                />
                                            )}
                                        </MenuTrigger>
                                        <MenuPopover>
                                            <MenuList>
                                                <MenuItem onClick={() => OnNewDocumentClick("/ConsultantsDocuments", "NavToConsultantsAllDoc", null, -1)}>{t('AddnewDocument')}</MenuItem>
                                            </MenuList>
                                        </MenuPopover>
                                    </Menu>
                                    <NavSubItem value="NavToConsultants">
                                        <ContactCardRibbon20Icon />{t('Identities')}
                                    </NavSubItem>
                                </NavSubItemGroup>
                            </NavCategory>
                            <NavCategory value="CatNeomyticBusiness">
                                <NavCategoryItem icon={<MoneyCalculator20Icon />} >Business</NavCategoryItem>
                                <NavSubItemGroup>
                                    <Menu>
                                        <MenuTrigger>
                                            {(triggerProps: MenuButtonProps) => (
                                                <SplitNavItem
                                                    navItem={{
                                                        icon: < CardUi20Icon />,
                                                        value: "NavToCustomers",
                                                        children: <>< CardUi20Icon />{t('Customers')}</>,
                                                    }}
                                                    menuButton={triggerProps}
                                                    menuButtonTooltip={{
                                                        content: t('MoreOptions'),
                                                        relationship: "label",
                                                    }}
                                                />
                                            )}
                                        </MenuTrigger>
                                        <MenuPopover>
                                            <MenuList>
                                                <MenuItem
                                                    onClick={() => {
                                                        navigate("/Customers");
                                                        setSelectedValue("NavToCustomers");
                                                        setSelectedCategoryValue("NavToCustomers");
                                                        const c: Customer = {
                                                            customerid: null,
                                                            displayName: null,
                                                            name: null,
                                                            address: null,
                                                            address2: null,
                                                            address3: null,
                                                            postalCode: null,
                                                            city: null,
                                                            country: null,
                                                            vat: null,
                                                            vatexempt: false,
                                                            vatcode: 21,
                                                            contacts: null,
                                                            defaultLanguage: null,
                                                            paymentTerms: 30,
                                                            isActif: true,
                                                            peppolIdentifier: null,
                                                            countryCode: null,
                                                            consultantid: NeomyticConsultantID, // neomytic consultant
                                                            sharedWithAllConsultants: false,
                                                        };
                                                        dispatch(customersActionCreators.requestCustomerEdition(c));
                                                        if (!isDesktop) setIsOpen(false);
                                                    }}
                                                >{t('AddCustomer')}</MenuItem>
                                            </MenuList>
                                        </MenuPopover>
                                    </Menu>
                                    <NavSubItem value="NavToContacts">
                                        <ContactCard20Icon />Contacts
                                    </NavSubItem>
                                    <NavSubItem value="NavToProjects">
                                        <TaskListSquareDatabase20Icon />{t('Projects')}
                                    </NavSubItem>
                                    <NavSubItem value="NavToProjectsAssigments">
                                        <TaskListSquarePerson20Icon />{t('ProjectsAssigments')}
                                    </NavSubItem>
                                </NavSubItemGroup>
                            </NavCategory>
                            <NavCategory value="Teamy">
                                <NavCategoryItem icon={<ShiftsTeam20Icon />}>Teamy</NavCategoryItem>
                                <NavSubItemGroup>
                                    <NavSubItem value="NavToProducts">
                                        <BoxSearch20Icon />Produits
                                    </NavSubItem>
                                </NavSubItemGroup>
                                <NavSubItemGroup>
                                    <NavSubItem value="NavToSales">
                                        <BoxArrowUp20Icon />Ventes
                                    </NavSubItem>
                                </NavSubItemGroup>
                            </NavCategory>
                        </>
                    }
                    <NavDivider />
                    {
                        //#region Consultant Menu
                    }
                    <NavSectionHeader>
                        {(consultantQuickView2 && consultantQuickView2.companyName
                            ?
                            consultantQuickView2.companyName
                            :
                            (consultantQuickView2.displayName
                                ?
                                consultantQuickView2.displayName
                                :
                                "?"))}
                    </NavSectionHeader>
                    <Menu>
                        <MenuTrigger>
                            {(triggerProps: MenuButtonProps) => (
                                <SplitNavItem
                                    navItem={{
                                        icon: < Timeline20Icon />,
                                        value: "NavToConsultantTimeSheet",
                                        children: t('MyTimeSheets'),
                                    }}
                                    menuButton={triggerProps}
                                    menuButtonTooltip={{
                                        content: t('MoreOptions'),
                                        relationship: "label",
                                    }}
                                />
                            )}
                        </MenuTrigger>
                        <MenuPopover>
                            <MenuList>
                                <MenuItem
                                    onClick={() => {
                                        navigate("/PrivateTimeSheet");
                                        setSelectedValue("NavToConsultantTimeSheet");
                                        setSelectedCategoryValue("NavToConsultantTimeSheet");
                                        const pa: TimeSheetEntry = {
                                            timesheetEntryid: null,
                                            projectAssignmentid: null,
                                            date: null,
                                            count: 0,
                                            invoiceid: null,
                                            description: null,
                                            timeSheetFileExist: undefined,
                                            invoiceDescription: null,
                                        };
                                        dispatch(dataActionCreators.requestTimeSheetEntryEdition(pa));
                                        if (!isDesktop) setIsOpen(false);
                                    }}
                                >{t('AddTimesheet')}</MenuItem>
                            </MenuList>
                        </MenuPopover>
                    </Menu>
                    <Menu>
                        <MenuTrigger>
                            {(triggerProps: MenuButtonProps) => (
                                <SplitNavItem
                                    navItem={{
                                        icon: < CardUi20Icon />,
                                        value: "NavToConsultantCustomrs",
                                        children: t('MyCustomers'),
                                    }}
                                    menuButton={triggerProps}
                                    menuButtonTooltip={{
                                        content: t('MoreOptions'),
                                        relationship: "label",
                                    }}
                                />
                            )}
                        </MenuTrigger>
                        <MenuPopover>
                            <MenuList>
                                <MenuItem
                                    onClick={() => {
                                        navigate("/CustomersFromConsultants");
                                        setSelectedValue("NavToConsultantCustomrs");
                                        setSelectedCategoryValue("NavToConsultantCustomrs");
                                        if (consultantid) {
                                            const c: Customer = {
                                                customerid: null,
                                                displayName: null,
                                                name: null,
                                                address: null,
                                                address2: null,
                                                address3: null,
                                                postalCode: null,
                                                city: null,
                                                country: null,
                                                vat: null,
                                                vatexempt: false,
                                                vatcode: 21,
                                                contacts: null,
                                                defaultLanguage: null,
                                                paymentTerms: 30,
                                                isActif: true,
                                                peppolIdentifier: null,
                                                countryCode: null,
                                                consultantid: consultantid,
                                                sharedWithAllConsultants: false,
                                            };
                                            dispatch(customersActionCreators.requestCustomerEdition(c));
                                            if (!isDesktop) setIsOpen(false);
                                        }
                                    }}
                                >{t('AddCustomer')}</MenuItem>
                            </MenuList>
                        </MenuPopover>
                    </Menu>
                    <Menu>
                        <MenuTrigger>
                            {(triggerProps: MenuButtonProps) => (
                                <SplitNavItem
                                    navItem={{
                                        icon: < DocumentDatabase20Icon />,
                                        value: "NavToConsultantDocss",
                                        children: t('MyDocuments'),
                                    }}
                                    menuButton={triggerProps}
                                    menuButtonTooltip={{
                                        content: "More options",
                                        relationship: "label",
                                    }}
                                />
                            )}
                        </MenuTrigger>
                        <MenuPopover>
                            <MenuList>
                                <MenuItem onClick={() => OnNewDocumentClick("/ConsultantsDocumentsPrivate", "NavToConsultantDocss", consultantid, -1)}>{t('AddnewDocument')}</MenuItem>
                            </MenuList>
                        </MenuPopover>
                    </Menu>
                    <Menu>
                        <MenuTrigger>
                            {(triggerProps: MenuButtonProps) => (
                                <SplitNavItem
                                    navItem={{
                                        icon: < BoxArrowUp20Icon />,
                                        value: "NavToConsultantSales",
                                        children: t('MySells'),
                                    }}
                                    menuButton={triggerProps}
                                    menuButtonTooltip={{
                                        content: t('MoreOptions'),
                                        relationship: "label",
                                    }}
                                />
                            )}
                        </MenuTrigger>
                        <MenuPopover>
                            <MenuList>
                                <MenuItem onClick={() => OnNewDocumentClick("/ConsultantsDocumentsPrivateMySells", "NavToConsultantSales", consultantid, 1)}>{t('AddnewDocument')}</MenuItem>
                                <MenuItem onClick={() => OnNewInvoiceClick(false, false)}>{t('AddNewPeppolSell')}</MenuItem>
                            </MenuList>
                        </MenuPopover>
                    </Menu>
                    <Menu>
                        <MenuTrigger>
                            {(triggerProps: MenuButtonProps) => (
                                <SplitNavItem
                                    navItem={{
                                        icon: < BoxArrowLeft20Icon />,
                                        value: "NavToConsultantBuys",
                                        children: t('MyBuys'),
                                    }}
                                    menuButton={triggerProps}
                                    menuButtonTooltip={{
                                        content: "More options",
                                        relationship: "label",
                                    }}
                                />
                            )}
                        </MenuTrigger>
                        <MenuPopover>
                            <MenuList>
                                <MenuItem onClick={() => OnNewDocumentClick("/ConsultantsDocumentsPrivateMyBuys", "NavToConsultantBuys", consultantid, 101)}>{t('AddnewDocument')}</MenuItem>
                            </MenuList>
                        </MenuPopover>
                    </Menu>
                    {
                        //#region Admin Menu
                    }
                    {isAdmin &&
                        <>
                            <NavDivider />
                            <NavSectionHeader>Admin</NavSectionHeader>
                            <NavItem
                                icon={<GlobeShield20Icon />}
                                value="NavToPeppolStatus" >
                                Peppol
                            </NavItem>
                            <NavItem
                                icon={<AppsListDetail20Icon />}
                                value="NavToLogs" >
                                Logs
                            </NavItem>
                        </>
                    }
                    <NavDivider />
                    {
                        //#region About Menu
                    }
                    <NavItem
                        icon={<Info20Icon />}
                        value="NavToAbout" >
                        {t("About")}
                    </NavItem>
                    {isAdmin && seeDebugInfo &&
                        <>
                            <NavDivider />
                            <Switch
                                label="Debug"
                                size="small"
                                checked={viewDebugInfo}
                                labelPosition="after"
                                onChange={() => { dispatch(UserLoginActionCreators.requestToogleDebugView()); }}
                            />
                        </>
                    }
                </NavDrawerBody>
            </NavDrawer>
            <ContentMotion visible={isOpen || !!qv}>
                <div id="LayoutContentMotionMain" className={styles.content}>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        {!(!isDesktop && qv) &&
                            <div style={{ display: "flex", flexDirection: "row", gap: "16px" }}>
                                <Tooltip content="Toggle navigation pane" relationship="label">
                                    <Hamburger
                                        onClick={() => setIsOpen(!isOpen)}
                                        {...restoreFocusTargetAttributes}
                                        aria-expanded={isOpen}
                                    />
                                </Tooltip>
                                <h1>{title}</h1>
                            </div>
                        }
                        {(!authStatus || !authStatus.InTeams) &&
                            <div style={{ display: "flex", flexDirection: "row", gap: "16px", alignItems: "center" }}>
                                <Button onClick={() => handleLogout(instance)}>Sign out</Button>
                                <select
                                    defaultValue={i18n.language}
                                    onChange={(e) => i18n.changeLanguage(e.target.value)}
                                    style={{ height: "31px", borderRadius: tokens.borderRadiusMedium }}
                                >
                                    {availableLanguages.map((language) => (
                                        <option key={language}>{language}</option>
                                    ))}
                                </select>
                                <select
                                    defaultValue={teamsState.themeString}
                                    onChange={(e) => {
                                        dispatch({ type: 'SET_THEMESTRING', themeString: e.target.value });
                                    }}
                                    style={{ height: "31px", borderRadius: tokens.borderRadiusMedium }}
                                >
                                    <option key={"webDarkTheme"}>{"webDarkTheme"}</option>
                                    <option key={"webLightTheme"}>{"webLightTheme"}</option>
                                    <option key={"teamsDarkV21Theme"}>{"teamsDarkV21Theme"}</option>
                                    <option key={"teamsLightV21Theme"}>{"teamsLightV21Theme"}</option>
                                    <option key={"default"}>{"default"}</option>
                                    <option key={"dark"}>{"dark"}</option>
                                    <option key={"contrast"}>{"contrast"}</option>
                                </select>
                            </div>
                        }
                    </div>
                    {version !== undefined && version > FEVersion &&
                        <MessageBar intent="error" className={stylesTab.layoutRootSpan2}>
                            <MessageBarBody>
                                <h2>{t('OldVersionWarning')}</h2>
                            </MessageBarBody>
                            {teamsState.InTeams &&
                                <MessageBarActions>
                                    <Button
                                        shape="circular"
                                        onClick={() => {
                                            NavToLink("https://crm.neomytic.be/");
                                        }}
                                    >
                                        {t('OldVersionWarningGoToWeb')}
                                    </Button>
                                </MessageBarActions>
                            }
                        </MessageBar >
                    }
                    {!isDesktop && qv ?
                        <div id="QV" key="QV" >
                            {qv}
                        </div>
                        :
                        children
                    }
                </div>
            </ContentMotion >

            {isDesktop && (
                <InlineDrawer
                    surfaceMotion={{ children: (_, props) => <DrawerMotion2 {...props} /> }}
                    open={!!qv}
                    position="end"
                    size="medium">
                    <DrawerBody>
                        {qv}
                    </DrawerBody>
                </InlineDrawer>
            )}

            {customerEdit !== null && <CustomersEditor />}
            {customerContactsEdit !== null && <CustomersContactManagement customerContactsEdit={customerContactsEdit} />}
            {data.projectEdit !== null && <ProjectEditor />}
            {data.projectAssigmentEdit !== null && <ProjectAssigmentEditor />}
            {projectContactsEdit !== null && <CustomersContactManagement projectContactsEdit={projectContactsEdit} />}
            {data.timeSheetEdit !== null && <TimeSheetEditor />}
            {data.timeSheetDelete !== null && <TimeSheetDeleteConfirm />}
            {data.FileUpload !== null && <FileUploader />}
            {data.invoiceEdit !== null && <InvoicesEditor />}
            {consultantEdit !== null && <ConsultantsEditor />}
            {data.salesEdit !== null && <SalesEditor />}
            {consultantInvoiceEdit !== null && <ConsultantsInvoicesEditor />}
            {contactsEdit !== null && <ContactEditor />}
            {consultantDocumentCreate !== null && <ConsultantsDocumentsCreation />}
            {consultantDocumentEdit !== null && <ConsultantsDocumentsEditor />}
            {consultantDocumentDelete !== null && <ConsultantDocumentDeleteConfirm />}
            {invoiceGeneration !== null && <InvoicesGeneration />}
            {invoiceEmail !== null && <InvoiceSendEmail />}
            {invoiceSendUBL !== null && <InvoicesSendUBL />}
            {invoiceToDelete !== null && <InvoiceDeleteConfirm />}
            {projectDelete !== null && <ProjectDeleteConfirm />}
            {projectAssigmentDelete !== null && <ProjectsAssigmentsDeleteConfirm />}
            {consultantActivityPeriodesEdit !== null && <ConsultantsActivityPeriodesEditor />}
            {peppolReceivedDocEdit !== null && <PeppolReceivedDocs />}
            {consultantPeppolReceivedInvoicedeletion !== null && <PeppolReceivedDocsDeleteConfirm />}
            {showAbout && <About closeDialog={() => setShowAbout(false)} />}
        </div >
    );
};